import cx from 'classnames';
import styles from './FooterCommonLink.module.scss';
import { ReactElement } from 'react';

interface FooterCommonLinkProps {
  label: string;
  iconLabel?: ReactElement;
  href?: string;
  className?: string;
  onClick?: () => void;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export const FooterCommonLink = ({
  label,
  iconLabel,
  href,
  className,
  onClick,
  target = '_self',
}: FooterCommonLinkProps) => {
  return onClick ? (
    <button
      onClick={onClick}
      className={styles['footer-common-link']}
      aria-label={label}
    >
      {iconLabel ? iconLabel : label}
    </button>
  ) : (
    <a
      rel="noopener noreferrer"
      href={href}
      target={target}
      className={cx(
        `${styles['footer-common-link']} exclude-global`,
        className
      )}
      aria-label={label}
    >
      {iconLabel ? iconLabel : label}
    </a>
  );
};
